import React from "react";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";

const { ACTIVE_FUNCTION, resolveActiveFunction } = SystemConstant;

// Map hiển thị (nhãn i18n + class màu chữ) cho cột/badge "Trạng thái hoạt động".
// Export để dialog Thông tin người dùng dùng chung, đảm bảo màu đồng bộ với bảng.
export const ACTIVE_FUNCTION_DISPLAY = {
  [ACTIVE_FUNCTION.DISABLED]: {
    label: LangConstant.L_FN_DISABLED,
    badgeClass: "badge badge-outline text-danger",
  },
  [ACTIVE_FUNCTION.LOGGED_IN]: {
    label: LangConstant.L_FN_LOGGED_IN,
    badgeClass: "badge badge-outline text-success",
  },
  [ACTIVE_FUNCTION.NOT_LOGGED_IN]: {
    label: LangConstant.L_FN_NOT_LOGGED_IN,
    badgeClass: "badge badge-outline text-warning",
  },
  [ACTIVE_FUNCTION.SUSPENDED]: {
    label: LangConstant.L_FN_SUSPENDED,
    badgeClass: "badge badge-outline text-secondary",
  },
};

/**
 * Cột "Trạng thái hoạt động".
 * - resolveActiveFunction trả về null → ô trống (INACTIVE/REJECT/DELETED khi branch_status=1,
 *   hoặc tổ hợp không khớp).
 * - FR-WA-03: không hiển thị nút Kích hoạt cho bản ghi "Chưa đăng nhập" (PENDING). Component này
 *   không render nút Kích hoạt (nút Kích hoạt là hành động hàng loạt trong Heading), nên chỉ cần
 *   hiển thị nhãn trạng thái.
 */
const UserActiveFunction = ({ user }) => {
  const { t: getLabel } = useTranslation();
  const activeFunction = resolveActiveFunction(user);

  if (!activeFunction) {
    return <span />;
  }

  const { label, badgeClass } = ACTIVE_FUNCTION_DISPLAY[activeFunction];

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span
        className={badgeClass}
        style={{ cursor: "default", width: "130px", display: "inline-block", textAlign: "center" }}
      >
        {getLabel(label)}
      </span>
    </div>
  );
};

export default UserActiveFunction;
